<ft-modal-editor-wrapper #wrapperRef [canSave]="canSave" [saveDisabled]="saveDisabled" [hasCloseButton]="hasCloseButton">
    <ng-template #triggerTmpl>
        <ng-content />
    </ng-template>
    <ng-content select="[content]" />
    <div *ngFor="let footerControlRef of footerControlsRef" class="ft2-edit-dialog_footer-control">
        <ng-container [ngTemplateOutlet]="footerControlRef" />
    </div>
</ft-modal-editor-wrapper>
